import React from 'react';
import { Alert as SpAlert } from '@tencent/spaui';

export const message = <>
  转化宝核心能力已整体迁移至客户工作台，<span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>当前转化宝独立网站将于 2025年10月1日起正式停止维护</span>，为不影响您的正常使用，建议：1.查看
  <a href="https://doc.weixin.qq.com/doc/w3_AHMAVga_ACcIe6NVW5SQbu50c540c?scode=AJEAIQdfAAoBsQLJ80AWcAdQbtAHc" target="_blank" rel="noopener noreferrer">产品手册</a>;2.进入
  <a href="https://ad.qq.com/cm/asset/agency-workspace/zhb/analysis" target="_blank" rel="noopener noreferrer">客户工作台</a>，提前熟悉产品功能与操作路径。如有疑问或建议，可联系您的专属行业运营反馈，我们将及时为您提供支持～
</>

const Alert = () => {
  return (
    <SpAlert type="info" message={message} />
  );
};

export default Alert;